import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaTabs from './VaTabs.vue'

export { default as VaTab } from './VaTab'

export default withConfigTransport(VaTabs)
